import { useRef } from 'react';

export const useDirtySet = () => {
  const dirtyIds = useRef(new Set<number>());

  const addDirty = (id: number) => {
    dirtyIds.current.add(id);
  };

  const removeDirty = (id: number) => {
    dirtyIds.current.delete(id);
  };

  const clearDirty = () => {
    dirtyIds.current.clear();
  };

  const hasDirty = () => dirtyIds.current.size > 0;

  return { addDirty, removeDirty, clearDirty, hasDirty };
};
